<mat-card>
    <div class="layout-padding-bottom__1rem">
        <span class="settings-heading">{{ pageTitle }}</span>
    </div>
    <div class="layout-padding-bottom__1rem row-layout-track">
        <div class="invoiced-loans-date-filter">
            <angular2-multiselect
                [data]="dateArray"
                [(ngModel)]="selectedDate"
                [settings]="dateFilterSettings"
                (onSelect)="onDateFilterChange($event)"
                (onDeSelect)="onDateFilterChange($event)"
                class="invoiced-loans-filter"
            >
            </angular2-multiselect>
            <span
                (click)="exportToExcel()"
                title="Download Excel"
                [hidden]="hideExcelExport"
                class="invoiced-loans-downloading-excel"
            >
                <mat-icon fontSet="far" fontIcon="fa-file-excel"></mat-icon>
            </span>
        </div>
        <div class="invoiced-loan-search-area">
            <search-dialog
                (searchOutput)="searchRows($event)"
                [searchId]="'invoiced-loans-search'"
                [searchBoxHeight]="44"
                [resetSearch]="false"
            >
            </search-dialog>
        </div>
    </div>
    <div>
        <custom-mat-table [customTableInfo]="customTableInfo"></custom-mat-table>
    </div>
</mat-card>
